import { AccommodationFilter, AccommodationSearch_Search } from "@graphql";

// TODO should be updated later
export type Filter = AccommodationFilter;

export const initialFilter: AccommodationFilter = {
  text: "",
  type: null,
  rooms: "",
  beds: "",
  location: {
    klm: "20",
    zipOrCity: ""
  },
  switches: []
};

export type Data = AccommodationSearch_Search.Return["getAccommodations"][0];

export type Header = {
  city: string;
  country: string;
};

export type Item = {
  _id: string;
  data: Data;
  header: Header;
};

export type Row =
  | (Item & { type: "card" })
  | {
      _id: string;
      type: "group";
      header: Header;
    };

export function getHeader(item: Data): Header | null {
  if (!item.Address) {
    return null;
  }
  const { Country, City } = item.Address;

  return { city: City, country: Country };
}

export function parseItems(items: Data[]): Row[] {
  const _items = items.map((item) => ({
    _id: item._id,
    data: item,
    header: getHeader(item)
  }));

  const result: Row[] = [];

  let prev = "";

  _items.forEach((item, i) => {
    const group = `${item.header.city} ${item.header.country}`;

    if (prev !== group) {
      i !== 0 &&
        result.push({
          _id: group,
          type: "group",
          header: getHeader(item.data)
        });

      prev = group;
    }

    result.push({ ...item, type: "card" });
  });

  return result;
}
